/** Dealers exempt from VMBI-only page/menu restrictions (full app access). */
export const VMBI_SUBSCRIPTION_EXEMPT_DEALER_IDS = new Set([25807, 52089]);

export function isVmbiSubscriptionExemptDealer(dealerId?: number | string | null): boolean {
  if (dealerId == null || dealerId === '') {
    return false;
  }
  return VMBI_SUBSCRIPTION_EXEMPT_DEALER_IDS.has(Number(dealerId));
}
